import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { ADMIN_PORTAL_CONFIG_MENU } from 'constants/wizardConstants';
import FinishedButton from 'components/Common/Buttons';

export const SetupStatus = ({ setStep }) => {
  return (
    <div>
      <div className="popup-header">
        <div className="header-container">
          <h1 className="large-title">{i18n.t('BTY_W_T_ALMOST_DONE')}</h1>
        </div>
      </div>
      <div className="popup-body">
        <div className="body-container">
          <p className="main-text">{i18n.t('BTY_W_T_SETUP_FINISH_T')}</p>
        </div>
        <div className="section">
          <FinishedButton
            label="BTY_W_T_ADD_JOBRANK"
            icon="ic_final_position"
            config={ADMIN_PORTAL_CONFIG_MENU.MEMBERSHIP}
          />
          <FinishedButton
            label="BTY_W_T_ADD_DEPT_BT"
            icon="ic_final_department"
            config={ADMIN_PORTAL_CONFIG_MENU.MEMBERSHIP}
          />
          <FinishedButton
            label="BTY_W_T_ADD_EMP"
            icon="ic_final_approval"
            config={ADMIN_PORTAL_CONFIG_MENU.MEMBERSHIP}
          />
          <FinishedButton label="BTY_W_T_ADD_BOARD" icon="ic_final_post" config={ADMIN_PORTAL_CONFIG_MENU.BOARD} />
          <FinishedButton
            label="BTY_W_T_ADD_MENU"
            icon="ic_final_menu"
            config={ADMIN_PORTAL_CONFIG_MENU.PORTALBUILDER}
          />
          <FinishedButton
            label="BTY_W_T_ADD_QUICK"
            icon="ic_final_quicklink"
            config={ADMIN_PORTAL_CONFIG_MENU.PORTALBUILDER}
          />
          <FinishedButton
            label="BTY_W_T_ADD_APPROVAL"
            icon="ic_final_payment"
            config={ADMIN_PORTAL_CONFIG_MENU.APPROVAL}
          />
          <FinishedButton
            label="BTY_W_T_ADD_ANNIVERSARY_BT"
            icon="ic_final_anniversary"
            config={ADMIN_PORTAL_CONFIG_MENU.SCHEDULE}
          />
        </div>
      </div>
    </div>
  );
};

SetupStatus.propTypes = {
  setStep: PropTypes.func.isRequired,
};
SetupStatus.defaultProps = {};
export default SetupStatus;
